import { api } from "@/api"

import type { CreateUpdateProductFormOutput } from "@/composables/forms/useCreateUpdateProductForm"
import { queryClient } from "@/queryClient"

export const createProduct = async (
  params: CreateUpdateProductFormOutput
): Promise<undefined> => {
  await api.post<unknown>("/products/products/", {
    body: params,
  })
  queryClient.invalidateQueries({
    queryKey: [BASE_PRODUCTS_QUERY_KEY],
  })
  return
}
